export default __webpack_public_path__ + "static/media/Archivo-VariableFont_wdth_wght.1a5ee99d.ttf";